import React from "react";
import { motion } from "framer-motion";

const TestimonialCard = ({
  image,
  name,
  role,
  quote,
  rating,
  animationDelay,
}) => {
  return (
    <motion.div
      className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all flex-shrink-0 w-80"
      initial={{ opacity: 0, y: 50, x: -20 }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5 + animationDelay, ease: "easeOut" }}
    >
      <div className="flex items-center mb-6">
        <img
          src={image}
          alt={name}
          className="w-16 h-16 rounded-full mr-4 object-cover"
        />
        <div>
          <h4 className="font-semibold">{name}</h4>
          <p className="text-emerald-600">{role}</p>
        </div>
      </div>
      <p className="text-gray-700 italic mb-4">"{quote}"</p>
      <div className="flex items-center">
        {Array.from({ length: 5 }).map((_, index) => (
          <i
            key={index}
            className={`fas fa-star ${
              index < rating ? "text-yellow-400" : "text-gray-300"
            }`}
          ></i>
        ))}
      </div>
    </motion.div>
  );
};

const FeedbackContainer = () => {
  const feedbackData = [
    {
      image:
        "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Amit Patel",
      role: "Professional Trader",
      quote:
        "AlgoTurtle has revolutionized my trading approach. The automated strategies have consistently outperformed my manual trading.",
      rating: 5,
    },
    {
      image:
        "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Priya Desai",
      role: "Algo Trading Expert",
      quote:
        "The platform's ease of use and powerful features make it perfect for both beginners and experienced traders.",
      rating: 4,
    },
    {
      image:
        "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Rahul Sharma",
      role: "Fund Manager",
      quote:
        "The backtesting capabilities and risk management features are exceptional. A must-have for serious traders.",
      rating: 5,
    },
    {
      image:
        "https://images.unsplash.com/photo-1502767089025-6572583495b9?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Neha Kapoor",
      role: "Investor",
      quote:
        "The insights and analytics provided by AlgoTurtle have helped me make informed investment decisions.",
      rating: 4,
    },
    {
      image:
        "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Suresh Mehta",
      role: "Day Trader",
      quote:
        "The platform's real-time data and execution speed are unmatched. Highly recommended!",
      rating: 5,
    },
    {
      image:
        "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Anjali Verma",
      role: "Swing Trader",
      quote:
        "AlgoTurtle's user-friendly interface and robust tools have made trading a breeze for me.",
      rating: 5,
    },
    {
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Karan Singh",
      role: "Technical Analyst",
      quote:
        "The charting tools and strategy builder are some of the best I've used. Highly recommended!",
      rating: 4,
    },
    {
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Meera Nair",
      role: "Portfolio Manager",
      quote:
        "AlgoTurtle's risk management features have helped me protect my portfolio while maximizing returns.",
      rating: 5,
    },
    {
      image:
        "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Ravi Kumar",
      role: "Investor",
      quote:
        "The platform's AI-driven insights have given me a significant edge in the market.",
      rating: 5,
    },
    {
      image:
        "https://images.unsplash.com/photo-1544725176-7c40e5a2c9f8?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
      name: "Sneha Roy",
      role: "Day Trader",
      quote:
        "The speed and accuracy of AlgoTurtle's execution have made it my go-to trading platform.",
      rating: 5,
    },
  ];

  return (
    <section className="py-10 bg-gray-100">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">
          What Our Traders Say
        </h2>
        <div className="overflow-x-auto">
          <div className="flex space-x-6 pb-4">
            {feedbackData.map((feedback, index) => (
              <TestimonialCard
                key={index}
                image={feedback.image}
                name={feedback.name}
                role={feedback.role}
                quote={feedback.quote}
                rating={feedback.rating}
                animationDelay={index * 0.1} // Different speed for each card
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeedbackContainer;
